module.exports = __webpack_public_path__ + "static/sotina-d389a75867b5ddab059fddffc10d661e.jpg";